// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: B956VVWhgfe
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Checkbox2 from "../../Checkbox2"; // plasmic-import: 3oEpY7J1Ez8/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingBizSuccess2.module.css"; // plasmic-import: B956VVWhgfe/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon
import image6EJgHdRnhX from "./images/image6.png"; // plasmic-import: eJGHdRnhX/picture

createPlasmicElementProxy;

export const PlasmicOnboardingBizSuccess2__VariantProps = new Array();

export const PlasmicOnboardingBizSuccess2__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingBizSuccess2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "checkAgree.isChecked",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__gdmJk)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__lcRvr
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox___7W3Mo)}>
            <div className={classNames(projectcss.all, sty.freeBox__uPyzg)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___7Jvyh)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__domk7)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___06XdO)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__fkjOk)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___9TIuO)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__h64O)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__wMHyf)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__rYSi)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___1Zwgj)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__djI2R)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__gTweW)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__bEeO2)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__eu9Yz)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox___2ZpxW)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__jzsv0
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__tCw7G
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ssBja
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__sBbM3
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__k2PAh
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__rjbsY)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___27QTc
                )}
              >
                {"Merchant Application"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__g2R7F
                )}
              >
                {
                  "Your account has just been approved for ACH processing. In order to continue with your application, please agree to our credit card processing partners' terms and conditions."
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___9YDgA)}>
                <Checkbox2
                  data-plasmic-name={"checkAgree"}
                  data-plasmic-override={overrides.checkAgree}
                  className={classNames("__wab_instance", sty.checkAgree)}
                  isChecked={
                    p.generateStateValueProp($state, [
                      "checkAgree",
                      "isChecked"
                    ]) ?? false
                  }
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "checkAgree",
                      "isChecked"
                    ])(eventArgs[0]);
                  }}
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ekbx6
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>
                      {"By checking this box you agree to our partner "}
                    </React.Fragment>
                    {
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__fiPrG
                        )}
                        href={"https://astrius.co/terms-of-service/"}
                        target={"_blank"}
                      >
                        {"ProPay's Terms and Conditions"}
                      </a>
                    }

                    <React.Fragment>
                      {" as well as our partner "}
                    </React.Fragment>
                    {
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__npJmX
                        )}
                        href={
                          "https://www.dwolla.com/legal/dwolla-account-terms-of-service/"
                        }
                        target={"_blank"}
                      >
                        {"Heartland's Terms and Conditions"}
                      </a>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
                <p.PlasmicImg
                  data-plasmic-name={"img"}
                  data-plasmic-override={overrides.img}
                  alt={""}
                  className={classNames(sty.img)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"87px"}
                  loading={"lazy"}
                  src={{
                    src: image6EJgHdRnhX,
                    fullWidth: 279,
                    fullHeight: 150,
                    aspectRatio: undefined
                  }}
                />
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0Rpup
                  )}
                >
                  {"Agree & Continue"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "checkAgree",
    "img",
    "continueButton"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  checkAgree: ["checkAgree"],
  img: ["img"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingBizSuccess2__ArgProps,
          internalVariantPropNames: PlasmicOnboardingBizSuccess2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingBizSuccess2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingBizSuccess2";
  } else {
    func.displayName = `PlasmicOnboardingBizSuccess2.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingBizSuccess2 = Object.assign(
  // Top-level PlasmicOnboardingBizSuccess2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    checkAgree: makeNodeComponent("checkAgree"),
    img: makeNodeComponent("img"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingBizSuccess2
    internalVariantProps: PlasmicOnboardingBizSuccess2__VariantProps,
    internalArgProps: PlasmicOnboardingBizSuccess2__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingBizSuccess2;
/* prettier-ignore-end */
